import { render, staticRenderFns } from "./ShowTastePanelResultPopUp.vue?vue&type=template&id=b2964bec&scoped=true&"
import script from "./ShowTastePanelResultPopUp.vue?vue&type=script&lang=js&"
export * from "./ShowTastePanelResultPopUp.vue?vue&type=script&lang=js&"
import style0 from "./ShowTastePanelResultPopUp.vue?vue&type=style&index=0&id=b2964bec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2964bec",
  null
  
)

export default component.exports